import { EmotionIconProps } from '@emotion-icons/emotion-icon'

export const DemographicsIcon = (props: EmotionIconProps) => {
  const { fill, color, size } = props
  return (
    <svg width={size} viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.3834 4.15066C15.3834 5.59627 14.2125 6.76714 12.7669 6.76714C11.3213 6.76714 10.1504 5.59627 10.1504 4.15066C10.1504 2.70505 11.3213 1.53418 12.7669 1.53418C14.2125 1.53418 15.3834 2.70505 15.3834 4.15066Z"
        fill={fill || color || 'currentColor'}
      />
      <path
        d="M11.7403 7.71669C12.1161 7.66512 12.4671 7.6393 12.7669 7.6393C14.5134 7.6393 17.9998 8.51582 17.9998 10.2558V12.0001H12.9998V10.0001C12.9998 9.13407 12.558 8.44947 12.0221 7.95486C11.9324 7.87206 11.8382 7.79271 11.7403 7.71669Z"
        fill={fill || color || 'currentColor'}
      />
      <path
        d="M5.99999 7C3.99749 7 0 8.005 0 9.99999V12H12V9.99999C12 8.005 8.00248 7 5.99999 7Z"
        fill={fill || color || 'currentColor'}
      />
      <path
        d="M8.99999 2.99999C8.99999 4.65749 7.65749 5.99999 5.99999 5.99999C4.3425 5.99999 3 4.65749 3 2.99999C3 1.3425 4.3425 0 5.99999 0C7.65749 0 8.99999 1.3425 8.99999 2.99999Z"
        fill={fill || color || 'currentColor'}
      />
    </svg>
  )
}
